import { FC } from "react";
import { FaInstagram, FaQuestion, FaSquareFacebook, FaTiktok, FaXTwitter } from "react-icons/fa6";
import { IoLogoYoutube } from "react-icons/io5";
import { SiLinkedin } from "react-icons/si";
import { SocialGroupType } from "src/lib/utils/types";

interface SalifySocialIconProps {
  type: SocialGroupType | undefined;
  size?: number;
  color?: string;
}

export const SalifySocialIcon: FC<SalifySocialIconProps> = ({ type, size, color }) => {
  const iconProps = { size, color };

  const renderIcon = () => {
    switch (type) {
      case "facebook":
        return <FaSquareFacebook {...iconProps} />;
      case "instagram":
        return <FaInstagram {...iconProps} />;
      case "twitter":
        return <FaXTwitter {...iconProps} />;
      case "linkedin":
        return <SiLinkedin {...iconProps} />;
      case "youtube":
        return <IoLogoYoutube {...iconProps} />;
      case "tiktok":
        return <FaTiktok {...iconProps} />;
      default:
        return <FaQuestion {...iconProps} />;
    }
  };

  return type ? renderIcon() : null;
};
